import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Icon } from '../Icon/Icon';
import { useUserSearch } from './hooks/useUserSearch';

import './UserSearch.scss';

const UserSearch = ({ onClose, searchtext }) => {
  const navigate = useNavigate();
  const { query, setQuery, results, loading, error } = useUserSearch();

  useEffect(() => {
    let id = setTimeout(() => {
      setQuery(searchtext);
    }, 500);
    return () => clearTimeout(id);
  }, [searchtext, setQuery]);

  const handleSelectUser = (user) => {
    if (!user || !user.id) return;
    onClose();
    navigate(`/profile/${user.id}`);
  };

  return (
    <div className='user-search-modal'>
      {error && <div className='user-search-error'>{error}</div>}

      <div className='user-search-results custom-scroller'>
        {loading && (
          <div className='user-search-loading'>
            <Icon
              name='Loading'
              size='sm'
              className='user-search-loading-icon'
              title='Searching'
            />
            <span className='user-search-loading-text'>Searching users...</span>
          </div>
        )}

        {!loading && !query && (
          <div className='user-search-empty'>
            Start typing a name to see matching users.
          </div>
        )}

        {!loading && query && results.length === 0 && !error && (
          <div className='user-search-empty'>No users found for this name.</div>
        )}

        {!loading && results.length > 0 && (
          <ul className='user-search-list'>
            {results.map((user) => (
              <li
                key={user.id}
                className='user-search-item'
                onClick={() => handleSelectUser(user)}
              >
                <div className='user-search-item-main'>
                  <Icon
                    name='User_Circle'
                    size='sm'
                    className='user-search-avatar'
                    title='User'
                  />
                  <div className='user-search-text'>
                    <div className='user-search-name'>
                      {user.full_name ||
                        user.fullName ||
                        `${user.first_name.String || ''} ${
                          user.last_name.String || ''
                        }`.trim() ||
                        user.username ||
                        user.email}
                    </div>
                    <div className='user-search-subtitle'>
                      {user.email || user.username || `User #${user.id}`}
                    </div>
                  </div>
                </div>
                <Icon
                  name='Arrow_Right_MD'
                  size='sm'
                  className='user-search-go-icon'
                  title='Open profile'
                />
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

UserSearch.propTypes = {
  onClose: PropTypes.func.isRequired,
  searchtext: PropTypes.string,
};

export default UserSearch;
